import { services } from '../../../../constants/services';
import { removeWithQueryParams } from '../../../../utils/api';

export class DeleteFileService {
	async run(params: any): Promise<void> {
		await removeWithQueryParams(`${services.rotationScreen}/deleteFile`, params);
	}
}

